import type { SVGProps } from 'react';
import { forwardRef, Ref } from 'react';

const SvgEyeClosed = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    viewBox="0 0 22 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    role="img"
    aria-hidden={true}
    ref={ref}
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.17614 7.69436L10.1375 9.19504C10.3987 9.07004 10.6912 9.00004 11 9.00004C12.1046 9.00004 13 9.89547 13 11C13 11.1231 12.9889 11.2435 12.9676 11.3604L15.4253 13.2408C16.1386 12.6494 16.8429 11.9046 17.5394 11C15.4409 8.27469 13.2718 7.00004 11 7.00004C10.0412 7.00004 9.10074 7.22707 8.17614 7.69436ZM6.43298 8.8789C5.7681 9.4501 5.11095 10.1554 4.46059 11C6.55906 13.7254 8.72821 15 11 15C11.8959 15 12.7759 14.8018 13.6419 14.3945L11.6693 12.8853C11.4601 12.9596 11.2347 13 11 13C9.89542 13 8.99999 12.1046 8.99999 11C8.99999 10.9487 9.00192 10.8977 9.00573 10.8473L6.43298 8.8789ZM4.81711 7.64258L1.39233 5.02224L2.60764 3.43384L6.45402 6.37675C7.89736 5.45894 9.41268 5.00004 11 5.00004C14.3137 5.00004 17.3137 7.00004 20 11C19.0543 12.4082 18.0697 13.5685 17.0462 14.481L20.6076 17.2058L19.3923 18.7942L15.3817 15.7256C13.9877 16.5752 12.5272 17 11 17C7.68628 17 4.68628 15 1.99999 11C2.90354 9.65462 3.84258 8.53546 4.81711 7.64258Z"
      fill="currentColor"
    />
  </svg>
);

/* eslint-disable import/no-default-export */
const ForwardRef = forwardRef(SvgEyeClosed);

export default ForwardRef;
